<template>
  <SSelect
    :value="value"
    :items="staffList"
    :label="label"
    item-value="id"
    :item-text="val => `${val.firstName} ${val.lastNme}`"
    hide-details
    @input="$emit('input', $event)"
  />
</template>

<script>
import { onMounted, ref } from '@/plugins/setup'
import { staffApi } from '@/apis'

// Replaces the free-text staffId box every new report screen originally shipped with (nobody
// can type a staff's Mongo ObjectId) - matches the item-text/item-value pattern already proven
// in StaffLeaveReport.vue.
export default {
  name: 'SStaffSelect',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: 'Staff' },
  },
  setup() {
    const staffList = ref([])

    onMounted(async () => {
      const res = await staffApi.getAllStaffByInstitude()
      if (res) staffList.value = res.responseObject || []
    })

    return { staffList }
  },
}
</script>
